export const formatAccessibleDate = (date: string | undefined): string | null => {
  if (!date) return null

  const [day, month, year] = date.split('/')
  const months = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ]
  return `${day} de ${months[Number(month) - 1]} de ${year}`
}
